import React, { FC } from 'react';
import EventCharts from '@components/machines/components/eventsChart';
import Paid from '@components/ncFiles/components/paid';
import PerformanceScreensWrapper from '@v2/pages/performance/common/components/PerformanceScreensWrapper';

interface PerformancePaidProps {}

const PerformancePaid: FC<PerformancePaidProps> = () => {
  return (
    <PerformanceScreensWrapper>
      <EventCharts getContentElement={(props) => <Paid {...props} />} />
    </PerformanceScreensWrapper>
  );
};

export default PerformancePaid;
